<script>
    import {PRODUCT_TYPE} from "../lib/constants";
    import R from "../lib/requests";
    import app from "../stores/app";
    import user from "../stores/user";
    import cart from "../stores/cart";
    import Modal from "../components/modal/Modal.svelte";
    import NumericControl from "../components/controls/NumericControl.svelte";
    import Notifier from "../stores/notifier";

    export let productId = null;

    let product = null;
    let quantity = 1;
    let totalPrice = 0;
    let disableCart = false;

    const load = () => {

        const onSuccess = result => {
            product = result;
            product.price = parseFloat(product.price);
            product.no_vat = ~~product.no_vat;
            product.requires_account = ~~product.requires_account;
            product.requires_subscription = ~~product.requires_subscription;
            // check if product exist in cart
            let item = $cart.products.find(x => x.id == product.id);
            if (item) {
                quantity = item.quantity;
            }

            disableCart = product.requires_subscription && !user.canBuyServices();
        }

        const onFailure = err => {

        };


        R.handle(R.product.details, productId, onSuccess, onFailure);
    }

    const addToCart = () => {
        if (quantity > 0) {
            cart.addToCart(product, quantity);
            Notifier.showMessage("Το προϊόν προστέθηκε στο καλάθι σας");
        } else {
            cart.removeFromCart(product.id);
            Notifier.showMessage("Το προϊόν αφαιρέθηκε από το καλάθι σας");
        }

        close();
    }

    const onShowLogin = () => {
        $user.showLogin = true;
    }

    const close = (param) => {
        product = null;

        if (param instanceof Event) {

            productId = null;
            return;
        }

        setTimeout(() => {
            productId = null;
        }, 200);
    }

    load();


    $: if (product != null) {
        totalPrice = product.price * quantity;
    }
</script>

{#if product}
    <Modal title="{ product.name }" modalMd on:close="{ close }">
        <div slot="body">
            <div class="row mb-4">
                <div class="col-lg-6 col-md-6">
                    <div class="image" class:no-image={ !product.image }>
                        {#if product.image}
                            <img src="{ $app.product_image_url }{ product.image }" alt="product image">
                        {:else}
                            <img src="/assets/images/product-logo.png" alt="product logo">
                        {/if}
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <h4 class="mb-4">{ product.name }</h4>
                    {#if product.requires_account && !$user.token}
                        <div class="alert alert-warning">
                            Για την αγορά { product.type == PRODUCT_TYPE.PRODUCT ? 'του προϊόντος' : 'της υπηρεσίας' }
                            απαιτείται η σύνδεση με τον λογαριασμό σας στον Π.Κ.Σ.
                        </div>
                        <button class="btn btn-primary btn-block" on:click={ onShowLogin }>Είσοδος Μέλους</button>
                    {:else}
                        {#if !disableCart}
                            <div class="form-group">
                                <label>Ποσότητα</label>
                                <NumericControl lg bind:value={ quantity } minValue="1"
                                                maxValue="{ product.max_quantity }"/>
                            </div>
                        {/if}
                        <div class="row align-items-center">
                            <div class="col-6 text-gray">
                                Τιμή:
                            </div>
                            <div class="col-6 text-end">
                                { product.price.toFixed(2) } €
                            </div>
                        </div>
                        {#if disableCart}
                            <div class="alert alert-warning mt-3">
                                Για την
                                αγορά { product.type == PRODUCT_TYPE.PRODUCT ? 'του προϊόντος' : 'της υπηρεσίας' }
                                απαιτείται η
                                τακτοποίηση των οικονομικών σας υποχρεώσεων
                                στον Π.Κ.Σ.
                            </div>
                        {:else}
                            <hr class="my-2">
                            <div class="row align-items-center">
                                <div class="col-6 text-gray">
                                    Σύνολο:
                                </div>
                                <div class="col-6 text-end total-price">
                                    {#if totalPrice > 0}
                                        <strong>{ totalPrice.toFixed(2) } €</strong>
                                    {/if}
                                </div>
                            </div>
                            {#if product.no_vat == 1}
                                <p class="small mt-2">Το προϊόν έχει <b>μηδενικό Φ.Π.Α.</b></p>
                            {:else}
                                <p class="small mt-2">Η τιμή δεν περιλαμβάνει Φ.Π.Α.</p>
                            {/if}
                            <hr class="my-2">
                            <button class="btn btn-success btn-block" on:click="{ addToCart }">Στο καλάθι</button>
                        {/if}
                    {/if}
                </div>
            </div>
            {#if product.content}
                <div>
                    {@html product.content }
                </div>
            {/if}
            <hr>
            <div class="text-end">
                <div class="btn btn-link fw-bold" on:click="{ () => close() }">Κλείσιμο</div>
            </div>
        </div>
    </Modal>
{/if}

<style>
    .total-price {
        font-size: 1.2rem;
    }

    .image {
        width: 100%;
        /*background: linear-gradient(to bottom, #3f6ab7 0%, #24509f 100%);*/
    }

    .image.no-image {
        padding: 30px;
    }

    .image img {
        width: 100%;
    }

    .image.no-image img {
        opacity: 0.5;
    }

    @media (max-width: 576px) {
        .image {
            margin-bottom: 1rem;
        }
    }
</style>